export const editorDummyServiceImages: Record<ServiceIndex, string> = {
  1: '11e50e_6051960c11f74af4a040953b473ddb98~mv2.png',
  2: '11e50e_112383fe578d4195805c34f86c8e1a85~mv2.png',
  3: '11e50e_ace9e0856b954060b898c6a7e26c1dc7~mv2.png',
  4: '11e50e_656128fe2fbe4c3aba7fda60244f6ba6~mv2.png',
};

export const studioDummyServiceImages: Record<ServiceIndex, string> = {
  1: '11e50e_0b8b0d7808ff4438b530ba8b48c9c799~mv2.png',
  2: '11e50e_c897d32be11846bfaf5c65eac3816132~mv2.png',
  3: '11e50e_469028f22775404fb7497aa10e1846f1~mv2.png',
  4: '11e50e_e178bffc6c26468db444ca3d15d3846a~mv2.png',
};

export const editor3DummyServiceImages: Record<ServiceIndex, string> = {
  1: '11e50e_04941a79a4984f50880eb5d58e1ba498~mv2.png',
  2: '11e50e_9762e356f1f24aa697413e46831f4e82~mv2.png',
  3: '11e50e_37b0262178d141668dbefdccc4a3c9ae~mv2.png',
  4: '11e50e_c4c438b308a240538589aed2fb616df4~mv2.png',
};

export type ServiceIndex = 1 | 2 | 3 | 4;
